import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/src/context/themeContext";

function ThemeSwitcher() {
  const { setTheme, theme } = useTheme();

  return (
    <div>
      {theme === "light" ? (
        <Sun
          onClick={() => setTheme("dark")}
          className="h-5 w-5 cursor-pointer "
        />
      ) : (
        <Moon
          onClick={() => setTheme("light")}
          className="h-5 w-5   dark:text-white cursor-pointer"
        />
      )}
      <span className="sr-only">Toggle theme</span>
    </div>
  );
}
export default ThemeSwitcher;
